"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RBMNVideo1Schema = void 0;
exports.RBMNVideo1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/rbmn-video/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "RBMNVideo1",
    "description": "Video served through the RedBull sparkle API (mediabase / cs.liiift.io)",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:rbmn-video:1"
            ]
        },
        "attributes": {
            "type": "object",
            "properties": {
                "assetId": {
                    "type": "string",
                    "pattern": "^([0-9]+-[0-9]+|AA-[A-Z0-9]{13}|AA[A-Z|0-9]{18})$"
                },
                "hideCornerLogo": {
                    "type": "boolean"
                },
                "mbEnvironment": {
                    "type": "string",
                    "description": "On which mediabase environment is the asset available (if not set, production is assumed)",
                    "enum": [
                        "production",
                        "staging"
                    ]
                },
                "VIN": {
                    "type": "string",
                    "pattern": "^MI[0-9]+$"
                }
            },
            "required": [
                "assetId",
                "VIN"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9yYm1uLXZpZGVvLzEuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsZ0JBQWdCLEdBQUc7SUFDOUIsS0FBSyxFQUFFLCtFQUErRTtJQUN0RixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxZQUFZO0lBQ3JCLGFBQWEsRUFBRSx5RUFBeUU7SUFDeEYsTUFBTSxFQUFFLFFBQVE7SUFDaEIsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLHVDQUF1QzthQUN4QztTQUNGO1FBQ0QsWUFBWSxFQUFFO1lBQ1osTUFBTSxFQUFFLFFBQVE7WUFDaEIsWUFBWSxFQUFFO2dCQUNaLFNBQVMsRUFBRTtvQkFDVCxNQUFNLEVBQUUsUUFBUTtvQkFDaEIsU0FBUyxFQUFFLG1EQUFtRDtpQkFDL0Q7Z0JBQ0QsZ0JBQWdCLEVBQUU7b0JBQ2hCLE1BQU0sRUFBRSxTQUFTO2lCQUNsQjtnQkFDRCxlQUFlLEVBQUU7b0JBQ2YsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLGFBQWEsRUFBRSwyRkFBMkY7b0JBQzFHLE1BQU0sRUFBRTt3QkFDTixZQUFZO3dCQUNaLFNBQVM7cUJBQ1Y7aUJBQ0Y7Z0JBQ0QsS0FBSyxFQUFFO29CQUNMLE1BQU0sRUFBRSxRQUFRO29CQUNoQixTQUFTLEVBQUUsWUFBWTtpQkFDeEI7YUFDRjtZQUNELFVBQVUsRUFBRTtnQkFDVixTQUFTO2dCQUNULEtBQUs7YUFDTjtTQUNGO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixZQUFZO1FBQ1osTUFBTTtLQUNQO0NBQ0YsQ0FBQSJ9